export const breakpoints = {
    tiny: 0,
    xxs: 360,
    xs: 480,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1600,
};

export type Breakpoints = 'tiny' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
